import React from 'react';
import { CircularProgress, Tooltip } from '@mui/material';
import styles from './BankActionBar.module.scss';

const cx = (...classes) => classes.filter(Boolean).join(' ');

const TONES = {
    blue: ['#304FFF', 'rgba(48, 79, 255, 0.1)'],
    teal: ['#009688', 'rgba(0, 150, 136, 0.1)'],
    green: ['#1B8A5A', 'rgba(27, 138, 90, 0.1)'],
    orange: ['#E57C22', 'rgba(229, 124, 34, 0.12)'],
    purple: ['#7B4DFF', 'rgba(123, 77, 255, 0.1)'],
};

const toneVars = (tone) => {
    const [color, soft] = TONES[tone] || TONES.blue;
    return { '--tone': color, '--tone-soft': soft };
};

const withTooltip = (tooltip, node) =>
    tooltip ? (
        <Tooltip title={tooltip} arrow>
            <span className={styles.tipWrap}>{node}</span>
        </Tooltip>
    ) : node;

export const BankActionBar = ({ direction, children }) => (
    <div className={styles.bar} dir={direction}>{children}</div>
);

export const BankActionGroup = ({ children }) => <div className={styles.group}>{children}</div>;

export const BankActionDivider = () => <span className={styles.divider} aria-hidden="true" />;

export const BankActionSpacer = () => <span className={styles.spacer} aria-hidden="true" />;

/**
 * `muted` keeps the button clickable (its handler explains what is missing) but greys it out;
 * `disabled` blocks the click entirely.
 */
export const BankActionButton = ({
    icon,
    label,
    tone = 'blue',
    primary = false,
    muted = false,
    busy = false,
    disabled = false,
    tooltip,
    onClick,
}) =>
    withTooltip(
        tooltip,
        <button
            type="button"
            className={cx(styles.btn, primary && styles.primary, muted && styles.muted)}
            style={toneVars(tone)}
            disabled={disabled || busy}
            onClick={onClick}
        >
            <span className={styles.icon}>{busy ? <CircularProgress size={14} color="inherit" /> : icon}</span>
            <span>{label}</span>
        </button>
    );

export const BankStatusPill = ({ color, label, tooltip }) =>
    withTooltip(
        tooltip,
        <span className={styles.statusPill} style={{ '--tone': color, '--tone-soft': `${color}1f` }}>
            <span className={styles.statusDot} />
            {label}
        </span>
    );
